"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetClose } from "@/components/ui/sheet";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function DesktopMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        {[1, 2, 3, 4, 5].map(i => <div key={i} className="h-4 w-16 animate-pulse rounded-md bg-white/10" />)}
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-0">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="group relative bg-transparent px-[1.1rem] py-2 font-['Manrope'] text-[14.5px] font-medium tracking-[0.005em] text-white/85 transition-colors hover:bg-transparent hover:text-white focus:bg-transparent">
                {item.label}
                <span className="absolute bottom-0 left-[1.1rem] right-[1.1rem] h-[2px] origin-left scale-x-0 rounded-lg bg-[#F5A623] transition-transform duration-350 ease-[cubic-bezier(0.4,0,0.2,1)] group-hover:scale-x-100" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-6 p-6">
        {[1, 2, 3, 4, 5].map(i => <div key={i} className="h-8 w-full animate-pulse rounded-md bg-white/10" />)}
      </div>;
  }
  return <nav className="flex flex-col px-6 pt-12">
      {menuItems.map((item, i) => <SheetClose asChild key={item.id}>
          <Link to={item.href || "#"} data-index={i} className="border-b border-white/8 py-4 text-xl font-semibold text-white transition-colors hover:text-[#F5A623]">
            {item.label}
          </Link>
        </SheetClose>)}
      <div className="mt-8 flex flex-col gap-4">
        <Link to="tel:0485000933" aria-label="Call Gold Garage Door" className="flex items-center justify-center gap-2 rounded-lg bg-[#F5A623] py-4 font-['Manrope'] text-lg font-bold text-[#081438]">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-5" aria-hidden="true" focusable="false"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg> Call Now — 0485 000 933
        </Link>
        <Link to="https://wa.me/61485000933" newTab aria-label="Message Gold Garage Door on WhatsApp" className="flex items-center justify-center gap-2 rounded-lg bg-[#25D366] py-4 font-['Manrope'] text-lg font-bold text-white">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-5" aria-hidden="true" focusable="false"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" /><path d="M8 12h.01" /><path d="M12 12h.01" /><path d="M16 12h.01" /></svg> WhatsApp Us
        </Link>
      </div>
    </nav>;
}
export default function NavigationHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <>
      <header id="navigation-header" className={`fixed top-0 left-0 right-0 z-50 w-full transition-all duration-350 ${isScrolled ? "bg-[#0d1e3a]/97 shadow-[0_1px_0_rgba(255,255,255,0.05),0_2px_8px_rgba(8,20,56,0.08),0_12px_40px_rgba(8,20,56,0.06)] backdrop-blur-[12px]" : "bg-[#0d1e3a]/80"}`}>
        <div className={`hidden border-b border-white/6 bg-[#081438] transition-all duration-350 md:block ${isScrolled ? "max-h-0 overflow-hidden opacity-0" : "max-h-[38px] opacity-100"}`}>
          
        </div>

        
      </header>

      <div className="fixed bottom-0 left-0 right-0 z-[9998] border-t border-white/8 bg-[#081438] px-4 pt-[10px] pb-[calc(10px+env(safe-area-inset-bottom))] md:hidden">
        <div className="flex gap-[10px]">
          <Link to="tel:0485000933" aria-label="Call Gold Garage Door" className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-[#F5A623] py-[14px] font-['Manrope'] text-sm font-bold text-[#081438]">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-[18px]" aria-hidden="true" focusable="false"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
            Call Now
          </Link>
          <Link to="https://wa.me/61485000933" newTab aria-label="Message Gold Garage Door on WhatsApp" className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-[#25D366] py-[14px] font-['Manrope'] text-sm font-bold text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-[18px]" aria-hidden="true" focusable="false"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" /><path d="M8 12h.01" /><path d="M12 12h.01" /><path d="M16 12h.01" /></svg>
            WhatsApp
          </Link>
        </div>
      </div>

      
    </>;
}